import Logo from "@/components/Logo";
import { BrandingWatermarkImage } from "@/components/branding/BrandingWatermarkImage";
import {
  resolveWatermarkLogoUrl,
  resolveWatermarkOpacity,
} from "@/components/branding/brandingUtils";
import type { BrandingConfig, EffectiveBranding, SurfaceBranding } from "@/services/api/agentic-v2/types";

export function BrandingWatermark({
  branding,
  isDark,
  className,
  imageClassName = "h-24 w-auto max-w-[280px] object-contain",
  defaultLogoClassName = "",
  useDefaultLogoWhenMissing = true,
  testId,
}: {
  branding: BrandingConfig | EffectiveBranding | SurfaceBranding | null | undefined;
  isDark: boolean;
  className?: string;
  imageClassName?: string;
  /** Optional class on the default Logo fallback (e.g. uniform scale in mini previews). */
  defaultLogoClassName?: string;
  /** When false, missing watermark.logo_url renders nothing (OS desktop). Previews pass true. */
  useDefaultLogoWhenMissing?: boolean;
  testId?: string;
}) {
  const logoUrl = resolveWatermarkLogoUrl(branding);
  const opacity = resolveWatermarkOpacity(branding);

  if (logoUrl) {
    return (
      <BrandingWatermarkImage
        logoUrl={logoUrl}
        opacity={opacity}
        className={className}
        imageClassName={imageClassName}
        testId={testId}
      />
    );
  }

  if (!useDefaultLogoWhenMissing) {
    return null;
  }

  return (
    <div className={className} style={{ opacity: opacity / 100 }} data-testid={testId}>
      <Logo
        variant={isDark ? "dark" : "light"}
        className={defaultLogoClassName}
        data-testid={testId ? `${testId}-default` : undefined}
      />
    </div>
  );
}
